export const formSubmitValueMapper = (data = {}) => ({
  id_item_aset: data.id_item_aset,
  id_analisa_checklist: data.id_analisa_checklist,
  analisa_checklist_detail: [
    ...data.detail_perlengkapan.map((val) => val.id_item_checklist),
    ...data.detail_fungsi.map((val) => val.id_item_checklist),
  ],
});
